export default "/images/framework/LoginRight.70df4521.svg?70df4521";